module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list-layout', {
    staticClass: "list-layout",
    attrs: {
      "pageSize": _vm.pageSize,
      "currentPage": _vm.currentPage,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleChange,
      "size-change": _vm.handleSizeChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("维修订单列表")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "slot": "search-bar",
      "inline": true
    },
    slot: "search-bar"
  }, [_c('el-form-item', {
    attrs: {
      "label": "物料名称"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "请输入物料名称/物料编码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleSearch($event)
      }
    },
    model: {
      value: (_vm.Search.Product),
      callback: function($$v) {
        _vm.Search.Product = $$v
      },
      expression: "Search.Product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "维修订单"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "请输入维修订单编码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleSearch($event)
      }
    },
    model: {
      value: (_vm.Search.OrderCode),
      callback: function($$v) {
        _vm.Search.OrderCode = $$v
      },
      expression: "Search.OrderCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单来源"
    }
  }, [_c('el-select', {
    staticClass: "form-input",
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择或输入订单来源"
    },
    model: {
      value: (_vm.Search.OrderType),
      callback: function($$v) {
        _vm.Search.OrderType = $$v
      },
      expression: "Search.OrderType"
    }
  }, _vm._l((_vm.OriginalOrderTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "维修类型"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择或输入维修类型"
    },
    model: {
      value: (_vm.Search.RepairType),
      callback: function($$v) {
        _vm.Search.RepairType = $$v
      },
      expression: "Search.RepairType"
    }
  }, _vm._l((_vm.RepairTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "维修时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "placeholder": "选择日期范围",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.warehouseDate),
      callback: function($$v) {
        _vm.warehouseDate = $$v
      },
      expression: "warehouseDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.IsLoading
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'NewRepair'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("新建维修单")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "slot": "tabs"
    },
    slot: "tabs"
  }, [_c('el-tabs', {
    staticClass: "tab",
    attrs: {
      "value": _vm.activename
    },
    on: {
      "tab-click": _vm.handleTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "all"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待确认",
      "name": "draft"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待收货",
      "name": "waitreceipt"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待质检",
      "name": "waitqc"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待复核",
      "name": "waitreview"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "维修中",
      "name": "repairing"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已完成",
      "name": "finished"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已取消",
      "name": "cancelled"
    }
  })], 1)], 1), _vm._v(" "), _c('complex-grid', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    attrs: {
      "slot": "main-content",
      "element-loading-text": "加载中",
      "config": _vm.tableConfig,
      "data": _vm.tableData
    },
    slot: "main-content",
    scopedSlots: _vm._u([{
      key: "sub-header",
      fn: function(props) {
        return [_c('el-col', {
          attrs: {
            "span": 21
          }
        }, [_c('span', [_vm._v(_vm._s(_vm._f("date")(props.row.OrderDate, 'YYYY-MM-DD HH:mm:ss')))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "20px"
          }
        }, [_vm._v("维修订单：" + _vm._s(props.row.Code))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "20px"
          }
        }, [_vm._v("订单来源：" + _vm._s(_vm._f("OrderSource")(props.row.OriginalOrderType)) + " "), (props.row.OriginalOrderType != null) ? _c('span', {
          staticStyle: {
            "color": "#20a0ff"
          }
        }, [_vm._v("(" + _vm._s(props.row.OriginalOrderCode) + ")")]) : _vm._e()]), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "20px"
          }
        }, [_vm._v("维修类型：" + _vm._s(_vm._f("RepairType")(props.row.RepairType)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "20px"
          }
        }, [_vm._v("维修数量：" + _vm._s(props.row.Quantity))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "20px"
          }
        }, [_vm._v("区域：" + _vm._s(_vm.region(props)))])]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 3
          }
        }, [_vm._v("\n        状态："), _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(_vm._f("ServiceState")(props.row.State)))])])]
      }
    }, {
      key: "BatchCode",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(_vm._f("NullShowCN")((props.row.Lot ? props.row.Lot.Code : props.row.LotCode))) + "\n    ")]
      }
    }, {
      key: "ProductName",
      fn: function(props) {
        return [_c('p', {
          staticStyle: {
            "margin": "4px 0"
          }
        }, [_vm._v(_vm._s(_vm._f("NullShowCN")((props.row.Lot ? props.row.Lot.Product.Name : props.row.ProductName))))]), _vm._v(" "), _c('p', {
          staticStyle: {
            "margin": "4px 0"
          }
        }, [_vm._v("物料编码：" + _vm._s(props.row.Lot ? props.row.Lot.Product.Code : '-'))])]
      }
    }, {
      key: "ProductConditionName",
      fn: function(props) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm._f("NullShowCN")((props.row.Lot && props.row.Lot.Condition ? props.row.Lot.Condition.Name : props.row.Condition.Name))))])]
      }
    }, {
      key: "BrandName",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(_vm._f("NullShowCN")((props.row.Lot && props.row.Lot.Product.Brand ? props.row.Lot.Product.Brand.Name : props.row.BrandName))) + "\n    ")]
      }
    }, {
      key: "ModelName",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(_vm._f("NullShowCN")((props.row.Lot && props.row.Lot.Product.Model ? props.row.Lot.Product.Model.Name : props.row.ModelName))) + "\n    ")]
      }
    }, {
      key: "ModuleName",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(_vm._f("NullShowCN")((props.row.Lot && props.row.Lot.Product.Module ? props.row.Lot.Product.Module.Name : props.row.ModuleName))) + "\n    ")]
      }
    }, {
      key: "action-bar",
      fn: function(props) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          nativeOn: {
            "click": function($event) {
              _vm.toDetail(props)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dda50d8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Repair/RepairListPage.vue
// module id = 771
// module chunks = 0